<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>edit</md-icon>
          </div>
          <h4 class="title">Update Category</h4>
        </md-card-header>

        <md-card-content>
          <md-field>
            <label>Title</label>
            <md-input v-model="title" type="text"></md-input>
          </md-field>
          <md-field>
            <label>Slug</label>
            <md-input v-model="slug" type="text"></md-input>
          </md-field>
          <md-field>
            <label>Description</label>
            <md-input v-model="description" type="text"></md-input>
          </md-field>

          <!-- Current Image Preview -->
          <div v-if="existingImageUrl" style="margin-bottom: 16px;">
            <p style="font-size: 13px; color: #888; margin-bottom: 6px;">Current Image</p>
            <img
              :src="existingImageUrl"
              alt="Current Category Image"
              style="width: 120px; height: auto; object-fit: cover; border-radius: 4px; border: 1px solid #ddd;"
            />
          </div>

          <md-field>
            <label style="margin-bottom: 6px;">Replace Image (optional)</label>
            <br />
            <input type="file" @change="fileUpload($event)" />
          </md-field>
        </md-card-content>

        <md-card-actions md-alignment="left">
          <md-button class="md-success" :disabled="isDisabled" @click="updateCategory()">
            Update <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
          </md-button>
          <md-button class="md-default" @click="$router.push('categories')">
            Cancel
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import CategoryService from "../../../services/CategoryService";

export default {
  components: {},
  data() {
    return {
      categoryId: this.$route.query.id,
      isDisabled: false,
      title: "",
      slug: "",
      description: "",
      categoryImage: "",
      existingImageUrl: "",
    };
  },
  methods: {
    fileUpload(event) {
      this.categoryImage = event.target.files[0];
    },

    getCategoryById() {
      CategoryService.getCategoryById(this.categoryId)
        .then((response) => {
          const category = response.data.data;
          this.title = category.title;
          this.slug = category.slug;
          this.description = category.description;
          this.existingImageUrl = category.categoryImageUrl;
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },

    async updateCategory() {
      this.isDisabled = true;
      let formData = new FormData();
      formData.append("id", this.categoryId);
      formData.append("title", this.title);
      formData.append("slug", this.slug);
      formData.append("description", this.description);
      if (this.categoryImage) {
        formData.append("categoryImage", this.categoryImage);
      }

      await CategoryService.updateCategory(formData)
        .then((response) => {
          this.isDisabled = false;
          this.$toast.success(response.data.respones_msg);
          this.$router.push("categories");
        })
        .catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
  },
  watch: {
    title(newTitle) {
      this.slug = newTitle
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");
    },
  },
  beforeMount() {
    if (!this.categoryId) {
      this.$toast.error("Category ID not found.");
      this.$router.push("categories");
      return;
    }
    this.getCategoryById();
  },
};
</script>

<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}
</style>